import { useEffect, useState } from "react";

import { getDeliveryType } from "src/api/master-data";
import { updateSellerDelivery } from "src/api/seller";

import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  IconButton,
  FormControl,
  FormGroup,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import Checkbox from "src/components/core/Checkbox";
import Loading from "src/components/ui/Loading";

import { DarkGrey } from "src/styles/color";
// import { useDialog } from "src/context/DialogContext";
import { useSnackbar } from "notistack";

const SetDeliveryTypeDialog = ({
  sellerId,
  sellerDeliveryTypes,
  onClose,
  onSuccess,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  // const { openDialog, closeDialog } = useDialog();

  const [deliveryTypeList, setDeliveryTypeList] = useState([]);
  const [seletedType, setSelectedType] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!!sellerDeliveryTypes) {
      setSelectedType(sellerDeliveryTypes);
    }
  }, [sellerDeliveryTypes]);

  useEffect(() => {
    fetchDelivery();
  }, []);

  const fetchDelivery = async () => {
    try {
      setIsLoading(true);
      const { data: res } = await getDeliveryType();
      setDeliveryTypeList(res);
    } catch (err) {
      console.error("err:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      const { data: res } = await updateSellerDelivery({
        _id: sellerId,
        seller_delivery_types: seletedType,
      });
      if (!!res) {
        enqueueSnackbar(`บันทึกสำเร็จ`, {
          variant: "success",
          autoHideDuration: 2000,
        });
        onSuccess();
      }
    } catch (error) {
      console.error(error.response.data);
      error.response.data.errors.forEach((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
          autoHideDuration: 2000,
        });
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnClose = () => {
    // openDialog({
    //   type: "confirm",
    //   title: `คุณต้องการออกจากหน้านี้ใช่หรือไม่`,
    //   onConfirm: () => {
    //     onClose();
    //   },
    //   maxWidth: 342,
    // });
    onClose();
  };

  // useEffect(() => {
  //   console.log("----------- seletedType ------------", seletedType);
  // }, [seletedType]);

  return (
    <Dialog
      onClose={handleOnClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 600,
            borderRadius: 4,
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3 }}>
        {/* <WrapperTitle>กำหนดประเภทการขนส่ง</WrapperTitle> */}

        <IconButton
          aria-label="close"
          onClick={handleOnClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ width: "100%", display: "flex" }}>
          <FormControl
            sx={{ width: "100%", maxWidth: "max-content", margin: "0 auto" }}
          >
            <FormLabel
              sx={{
                color: DarkGrey,
                lineHeight: 3,
                marginTop: 1,
                "&.Mui-focused": {
                  color: DarkGrey,
                },
              }}
            >
              กำหนดประเภทการขนส่ง
            </FormLabel>
            <FormGroup
              sx={{ width: "100%", flexDirection: "row" }}
              onChange={(e) => {
                let itemDetail = seletedType;
                if (e.target.checked) {
                  itemDetail.push(e.target.value);
                } else {
                  itemDetail = itemDetail.filter(
                    (item) => item !== e.target.value
                  );
                }
                setSelectedType([...itemDetail]);
              }}
            >
              {deliveryTypeList.map((type, index) => (
                <FormControlLabel
                  key={`type-${index}`}
                  control={
                    <Checkbox
                      checked={seletedType?.includes(type?._id) ? true : false}
                      value={type?._id}
                      disabled={type?.type_en === "Grab"}
                      name={type?.type_en}
                    />
                  }
                  label={type?.type_en}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Stack alignItems="center" flexDirection="row" gap={2}>
          <Button
            variant="outlined"
            // size="large"
            onClick={() => handleOnClose()}
            sx={{
              minWidth: 140,
            }}
          >
            ยกเลิก
          </Button>

          <Button
            variant="contained"
            // size="large"
            onClick={() => handleSave()}
            sx={{
              minWidth: 140,
            }}
          >
            บันทึก
          </Button>
        </Stack>
      </DialogActions>

      {isLoading && <Loading />}
    </Dialog>
  );
};

export default SetDeliveryTypeDialog;
